// extracted by mini-css-extract-plugin
export var container = "styles-module__container___kny6y";
export var innerContainer = "styles-module__innerContainer___MkWJH";
export var textContainer = "styles-module__textContainer___W49bX";
export var title = "styles-module__title___pq97_";
export var header = "styles-module__header___TdARl";
export var subHeader = "styles-module__subHeader___XodRY";
export var valueContainer = "styles-module__valueContainer___qBHUz";
export var value = "styles-module__value___Qek1Y";
export var valueDesc = "styles-module__valueDesc___qd5wa";